import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { App } from "./App.js";
import "./styles.css";

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root element");

// Data router (RouterProvider) is required for useBlocker on the edit page.
// App still uses <Routes> internally — this only swaps how the router boots.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
